var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScreenOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.02765 13.3287L8.70352 7.51498L9.61192 7.93309L6.93605 13.7468L6.02765 13.3287Z",
    fill: "#788B9C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 13C6.4 13 6.6 13 6.5 13C6.2 13 6 13.2 6 13.5C6 13.8 6.2 14 6.5 14C6.6 14 6.4 14 6.5 14C6.8 14 7 13.8 7 13.5C7 13.2 6.8 13 6.5 13Z",
    fill: "#36404D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.40561 7.88739L10.3141 7.46957L12.9882 13.2842L12.0796 13.702L9.40561 7.88739Z",
    fill: "#788B9C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 13C12.6 13 12.4 13 12.5 13C12.8 13 13 13.2 13 13.5C13 13.8 12.8 14 12.5 14C12.4 14 12.6 14 12.5 14C12.2 14 12 13.8 12 13.5C12 13.2 12.2 13 12.5 13Z",
    fill: "#36404D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 0H10V13H9V0Z",
    fill: "#66798F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 1.5H14.5V10.5H3.5V1.5Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14 2V10H4V2H14ZM15 1H3V11H15V1Z",
    fill: "#F78F8F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2 1H16V2H2V1Z",
    fill: "#E1EBF2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16 1H2V2H16V1Z",
    fill: "#F78F8F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M4 2H6V1H3V10.8H4V2Z",
    fill: "#E1EBF2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M3 0.5C2.80302 0.5 2.60796 0.538799 2.42597 0.614181C2.24399 0.689563 2.07863 0.800052 1.93934 0.93934C1.80005 1.07863 1.68956 1.24399 1.61418 1.42597C1.5388 1.60796 1.5 1.80302 1.5 2C1.5 2.19698 1.5388 2.39204 1.61418 2.57403C1.68956 2.75601 1.80005 2.92137 1.93934 3.06066C2.07863 3.19995 2.24399 3.31044 2.42597 3.38582C2.60796 3.4612 2.80302 3.5 3 3.5C3.19698 3.5 3.39204 3.4612 3.57403 3.38582C3.75601 3.31044 3.92137 3.19995 4.06066 3.06066C4.19995 2.92137 4.31044 2.75601 4.38582 2.57403C4.4612 2.39204 4.5 2.19698 4.5 2C4.5 1.80302 4.4612 1.60796 4.38582 1.42597C4.31044 1.24399 4.19995 1.07863 4.06066 0.93934C3.92137 0.800052 3.75601 0.689563 3.57403 0.614181C3.39204 0.538799 3.19698 0.5 3 0.5Z",
    fill: "#FFEEA3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M3 1C3.6 1 4 1.4 4 2C4 2.6 3.6 3 3 3C2.4 3 2 2.6 2 2C2 1.4 2.4 1 3 1ZM3 0C1.9 0 1 0.9 1 2C1 3.1 1.9 4 3 4C4.1 4 5 3.1 5 2C5 0.9 4.1 0 3 0Z",
    fill: "#BA9B48"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 15.5V10.9L0.5 10.6V6C0.5 5.2 1.2 4.5 2 4.5H7.5C8.1 4.5 8.5 4.9 8.5 5.5C8.5 6.1 8.1 6.5 7.5 6.5H4.4L3.6 15.5H1.5Z",
    fill: "#8BB7F0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 5C7.8 5 8 5.2 8 5.5C8 5.8 7.8 6 7.5 6H4.8H3.9L3.8 6.9L3.1 15H2V11.2V10.4L1.2 10.2H1V6C1 5.4 1.4 5 2 5H4H7.5ZM7.5 4H4H2C0.9 4 0 4.9 0 6V11L1 11.3V16H4L4.8 7H7.5C8.3 7 9 6.3 9 5.5C9 4.7 8.3 4 7.5 4Z",
    fill: "#4E7AB5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M14 3.5C14.8284 3.5 15.5 2.82843 15.5 2C15.5 1.17157 14.8284 0.5 14 0.5C13.1716 0.5 12.5 1.17157 12.5 2C12.5 2.82843 13.1716 3.5 14 3.5Z",
    fill: "#F78F8F",
    stroke: "#C74343"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenOn);
export default __webpack_public_path__ + "static/media/screen--on.d33ed815706d3b77072714c7abc587d0.svg";
export { ForwardRef as ReactComponent };